<template>
    <div class="navbar-wrapper">
        <div class="navbar" ref="navbar">
            <div class="nav-logo">
                <router-link to="/">
                    <Logo></Logo>
            </router-link>
        </div>

        
            <!-- <div class="element mobile-disable">
                <div class="link" @click="scrollIntoView('projects')">
                    Projects
                </div>
            </div> -->
            <!-- <div class="element mobile-disable">
                <div class="link" @click="scrollIntoView('about')">
                    About
                </div>
            </div> -->
            <div class="element">
                <a class="cta" href="https://www.linkedin.com/in/felix-tesche-5969b7173/" target="_blank">
                        Say Hi 👋
                    </a> 
                </div>
            </div>
    </div>
</template>

<script>
    import Logo from '@/components/Logo.vue'
    export default {
        components: {
            Logo
        },
        methods : {
            scrollIntoView (id) {
                document.getElementById(id).scrollIntoView({
                    behavior: 'smooth'
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/base.scss';

    .navbar-wrapper {
        position: fixed;
        left: 0;
        width: 100vw;
        z-index: 100;
    }
    .navbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: calc(1280px);
        margin: 0 auto;
        padding: 1.5rem 0;
        @include md () {
            align-items: center;
        }
        .mobile-disable {
            @include md() {
                display: none;
            }
        }
    }

    .element .link {
        cursor: pointer;
    }

    .nav-logo {
        @include md () {
            margin-left: .5rem;
            width: 20%;
        }
    }

    .nav-elements {
        display: flex;
        justify-items: end;
        align-items: baseline;
        @include md () {
            margin-right: 1.5rem;
        }
    }

    
</style>